export default __webpack_public_path__ + "static/carousel-develop-e1721294ef42bf740c7b40b99a5c5d1c.svg";